import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { ORDER_STATUS_PAGE_ACTIONS } from './store/actions/order-status.actions';
import { OrderStatusFilters } from '@usf/user-types/user-preferencev2';
@Injectable({
  providedIn: 'root',
})
export class OrderStatusPageService {
  constructor(private store: Store) {}

  saveFilterPreferences(
    orderStatusFilters: OrderStatusFilters,
    rememberSelections?: {
      orderStatus: boolean;
      customers: boolean;
      deliveryMethod: boolean;
      deliveryDatePreset: boolean;
    },
  ) {
    this.store.dispatch(
      ORDER_STATUS_PAGE_ACTIONS.postOrderStatusFilterPreferences({
        orderStatusFilters: orderStatusFilters,
        rememberSelections: rememberSelections || {
          orderStatus: false,
          customers: false,
          deliveryMethod: false,
          deliveryDatePreset: false,
        },
      }),
    );
  }
}
